<template>
	<v-overlay z-index="100000" :opacity="0.4" :value="value">
		<v-snackbar
				class="ConfirmEmailSending"
				:timeout="1000000"
				top
				:value="value"
		>
			<button class="ConfirmEmailSending_close" type="button" @click="onConfirmClose">
				<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
			</button>
			<div class="ConfirmEmailSending_title">
				Send report to email
			</div>
			<div class="bodyM">
				<field
						margin="10px 0"
						label="Email"
						placeholder="Enter email"
						@updateInput="onInput($event)"
						:setInputValue="email"
						is-required
				></field>
			</div>
			<button-groups
					@updateBtnClose="onConfirmClose"
					@updateSave="onConfirmItem"
					applyText="send"
			></button-groups>
		</v-snackbar>
	</v-overlay>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups.vue";

export default {
	name: "ConfirmEmailSending",
	components: { ButtonGroups },
	props: {
		isConfirm: Boolean,
		preloader: Boolean,
		email: String
	},
	data: () => ({
		value: true
	}),
	methods: {
		onConfirmItem() {
			this.$emit('updateConfirmItem');
		},
		onConfirmClose() {
			this.$emit('updateConfirmClose');
		},
		onInput({ value }) {
			this.$emit('updateConfirmEmailSending', value);
		},
	}
};
</script>

<style lang="scss">
.ConfirmEmailSending {
	position: relative;
	align-items: center;
	&_title {
		margin-bottom: 20px;
		font-size: 20px;
	}
	&_subTitle {
		margin-bottom: 30px;
		font-size: 14px;
	}
	&_close {
		position: absolute;
		top: 20px;
		right: 20px;
	}
	.v-snack__content {
		padding: 20px;
	}
	.v-snack__wrapper {
		background-color: #22222d;
		border-radius: 4px;
		box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.30);
	}
	.v-application--is-ltr .v-snack__action {
		margin-right: 0;
	}
	.v-snack__action {
		display: none;
	}
	.buttonGroups {
		justify-content: space-between;
		gap: 10px;
		.customBtn {
			margin: 0;
			width: 100% !important;
		}
	}
}
</style>
